module.exports = __webpack_public_path__ + "img/avatar_placeholder.958f92c3.svg";